import { createContext, useContext, useEffect, useState } from 'react';
import { useStateInRef } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
const GoogleMapsContext = /*#__PURE__*/createContext(undefined);
export const useGoogleMaps = () => useContext(GoogleMapsContext);
export default function GoogleMapsProvider(props) {
  const getProps = useStateInRef(props);
  const [googleMaps, setGoogleMaps] = useState();
  useEffect(() => {
    getProps().loadGoogleMaps().then(setGoogleMaps);
  }, []);
  return /*#__PURE__*/_jsx(GoogleMapsContext.Provider, {
    value: googleMaps,
    children: props.children
  });
}